import { NotifyHelper } from './../../../helpers/toast';
import { eLegalGroupDefine } from '../../action-types/legal-document/ILegalGroupActionTypes';
import { generateActionForKey, generateActions } from '../generateActions';
export const legalGroupActions = {
    ...generateActions(eLegalGroupDefine, "LEGAL_GROUP"),
    ...generateActionForKey(eLegalGroupDefine, "LEGAL_GROUP", "LOAD_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eLegalGroupDefine, "LEGAL_GROUP", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eLegalGroupDefine, "LEGAL_GROUP", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eLegalGroupDefine, "LEGAL_GROUP", "DELETE_SUCESSS", () => { NotifyHelper.Success("Deleted!") }),
    ...generateActionForKey(eLegalGroupDefine, "LEGAL_GROUP", "SAVE_SUCESSS", () => { NotifyHelper.Success("Saved!") }),
}